<template>
  <div class="card dashboard-widget message-flow-widget">
    <div class="card-header">MESSAGES BY FLOW</div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12" v-if="flowStat && flowStat.length > 1">
          <apexchart
            type="bar"
            :series="seriesData"
            :options="seriesOptions"></apexchart>
        </div>
        <div class="col-sm-12 text-center no-data-text" v-else>
          No data
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

const ChartColor = [
  '#3366CC',
  '#DC3912',
  '#FF9900',
  '#109618',
  '#990099',
  '#3B3EAC',
  '#0099C6',
  '#DD4477',
  '#66AA00',
  '#B82E2E',
  '#316395',
  '#994499',
  '#22AA99',
  '#AAAA11',
  '#6633CC',
  '#E67300',
  '#8B0707',
  '#329262',
  '#5574A6',
  '#3B3EAC',
];

export default {
  name: 'message-category-widget',
  props: {
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      seriesData: [],
      seriesOptions: {},
    };
  },
  watch: {
    criteria: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      loadFlowStatData: 'dashboard/loadFlowStatData',
    }),
    async init() {
      await this.loadFlowStatData({
        criteria: this.criteria,
      });
      const sortedFlowStat = this.getSortedFlowStat();
      // Generate Options?
      this.seriesOptions = this.getSeriesOptions(sortedFlowStat);
      // Generate Series?
      const finalData = [];
      if (sortedFlowStat) {
        for (let i = 0; i < sortedFlowStat.length; i += 1) {
          const modelData = sortedFlowStat[i];
          finalData.push(modelData.conversationCount);
        }
      }
      this.seriesData = [{
        name: 'จำนวนข้อความ',
        data: finalData,
      }];
    },
    getSortedFlowStat() {
      if (this.flowStat) {
        return [...this.flowStat].sort((a, b) => b.conversationCount - a.conversationCount);
      }
      return [];
    },
    getSeriesOptions(sortedFlowStat) {
      const categories = [];
      // const colors = [];
      if (sortedFlowStat) {
        for (let i = 0; i < sortedFlowStat.length; i += 1) {
          // colors.push(ChartColor[i]);
          categories.push(sortedFlowStat[i].id);
        }
        const height = this.getSeriesHeight(sortedFlowStat);
        return {
          plotOptions: {
            bar: {
              horizontal: true,
              distributed: true,
              dataLabels: {
                position: 'top',
                maxItems: 100,
                hideOverflowingLabels: true,
                orientation: 'horizontal',
              },
            },
          },
          legend: {
            show: false,
          },
          grid: {
            show: true,
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          colors: ChartColor,
          stroke: {
            show: true,
            width: 2,
            colors: ['#fff'],
          },
          xaxis: {
            categories,
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '14px',
              },
            },
          },
          chart: {
            height,
            id: 'message-flow',
          },
        };
      }
      return {};
    },
    getSeriesHeight(sortedFlowStat) {
      let calHeight = 500;
      if (sortedFlowStat && sortedFlowStat.length > 0) {
        calHeight = Math.max(sortedFlowStat.length * 50, 500);
      }
      return `${calHeight}px`;
    },
  },
  computed: {
    ...mapGetters({
      flowStat: 'dashboard/flowStat',
    }),
  },
};
</script>
<style lang="scss" scoped>
  .message-flow-widget {
    .no-data-text {
      font-size: 12px;
      color: #aaa;
      line-height: 42px;
    }
  }
</style>
